import Mooring from './Mooring';
export default class MooringBeforeDeparture extends Mooring {
    statementForShipSafetyAndIntegrity;
    constructor(port, freeText, statementForShipSafetyAndIntegrity) {
        super(port, freeText);
        this.statementForShipSafetyAndIntegrity = statementForShipSafetyAndIntegrity;
    }
}
//# sourceMappingURL=MooringBeforeDeparture.js.map